import type { UserRole } from "./types";

/**
 * UI role helpers. These MIRROR the server guards in server/auth.ts — they do not
 * enforce anything. Hiding a button is not a permission; the server is the control.
 * Kept in one file so the two never drift apart silently.
 *
 * "admin" is legacy (pre-2026-08-18) and counts as a manager.
 */
export function isStaff(role: UserRole) {
  return role === "account_manager" || role === "manager" || role === "admin" || role === "superadmin";
}

export function isManager(role: UserRole) {
  return role === "manager" || role === "admin" || role === "superadmin";
}

/** Can create clients and users, and change anybody's role. */
export function isSuperadmin(role: UserRole) {
  return role === "superadmin";
}

/**
 * A role as a TRANSLATION KEY. It sits under the reader's own name in the sidebar,
 * which made "Client" the one English word on an otherwise Arabic screen — and the
 * one a reader looks at most, because it is next to them.
 */
export function roleLabelKey(role: UserRole): string {
  switch (role) {
    case "manager": return "role.manager";
    case "account_manager": return "role.account_manager";
    case "admin": return "role.admin";
    case "superadmin": return "role.superadmin";
    default: return "role.client";
  }
}
